import type { Result } from '../core/result';
import { ok, err } from '../core/result';
import type { RawPainterView, CameraPose, DataError } from './types';

export function toCameraPose(raw: RawPainterView): Result<CameraPose, DataError> {
  const three = raw.three;

  if (!three || !three.position || !three.target || !three.up) {
    return err({
      file: 'painterView',
      kind: 'schema',
      message: 'Missing three.js camera data in painterView',
      details: ['Expected three.position, three.target, three.up'],
    });
  }

  const position = three.position;
  const target = three.target;
  const up = three.up;

  if (typeof raw.fovYDeg !== 'number' || !isFinite(raw.fovYDeg) || raw.fovYDeg <= 0) {
    return err({
      file: 'painterView',
      kind: 'schema',
      message: 'Invalid fovYDeg in painterView',
      details: ['fovYDeg must be a positive number'],
    });
  }

  if (typeof raw.aspect !== 'number' || !isFinite(raw.aspect) || raw.aspect <= 0) {
    return err({
      file: 'painterView',
      kind: 'schema',
      message: 'Invalid aspect in painterView',
      details: ['aspect must be a positive number'],
    });
  }

  return ok({
    position,
    target,
    up,
    fovYDeg: raw.fovYDeg,
    aspect: raw.aspect,
  });
}
